var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'box-cards-container',
    ( _obj = {}, _obj['box-cards-container--scroll'] = _vm.isScrollEnabled, _obj ) ]},[(_vm.isScrollEnabled)?_c('div',{staticClass:"box-cards-container__scroll"},[_vm._t("default")],2):_c('wrapper',[_c('Carousel',{attrs:{"max-visible":_vm.maxVisible}},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }